 /*=========================================================================================
  File Name: state.js
  Description: Products State
  ----------------------------------------------------------------------------------------
  Item Name: Products State Module
  Author: Tan Tran
==========================================================================================*/

export default {
    taxes : [],
    products: [],
    categoriesFromProductsList: []
}